import { useEffect, RefObject } from 'react';

interface useKeyScrollOptions {
  scrollContainer: RefObject<HTMLElement>;
  scrollAmount: number;
}

export const useKeyScroll = ({
  scrollContainer,
  scrollAmount,
}: useKeyScrollOptions) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!scrollContainer.current) {
        return;
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault();
        scrollContainer.current.scrollTop -= scrollAmount;
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        scrollContainer.current.scrollTop += scrollAmount;
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [scrollContainer, scrollAmount]);
};
